<template>
  <div @click="sendEmails()" class="ml-2">
    <i class="fa fa-envelope fa-fw mr-2"></i> Enviar emails a los clientes <custom-loader v-if="showLoader" />
  </div>
</template>

<script>
import CustomLoader from "../CustomLoader/ClipLoader";

export default {
  components: {
    CustomLoader,
  },
  data() {
    return {
      showLoader: false
    }
  },
  methods: {
    async sendEmails() {
      this.showLoader = true;
      let date = this.$store.getters.filterDate;
      await this.$store.dispatch("sendgrid/sendEmails", date);
      this.showLoader = false;
    }
  }
};
</script>